var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{staticClass:"pa-4",attrs:{"outlined":""}},[_c('div',{staticClass:"text-h5 mb-4"},[_vm._v("Additional information")]),_c('div',{staticClass:"border-1s pa-2"},[_c('tip-tap',{attrs:{"big":true,"sma":true},on:{"text":_vm.getText}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }